export const XaiLogo = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Grok</title>
      <defs>
        <linearGradient
          id="lobe-icons-xai-fill"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="0%"
        >
          <stop offset="0%" stopColor="#00055F" stopOpacity="0.84" />
          <stop offset="100%" stopColor="#6F69F7" stopOpacity="0.84" />
        </linearGradient>
      </defs>
      <path
        d="M6.469 8.776L16.512 23h-4.464L2.005 8.776H6.47zm-.004 7.9l2.233 3.164L6.467 23H2l4.465-6.324zM22 2.582V23h-3.659V7.764L22 2.582zM22 1l-9.952 14.095-2.233-3.163L17.533 1H22z"
        fill="url(#lobe-icons-xai-fill)"
        fillRule="nonzero"
      />
    </svg>
  );
};
